import { MAIN_QUESTS_GROUP } from "@/constants";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const triumphConnectQuests: Quest[] = [
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow on X",
    caption: "Don't miss a tweet",
    linkUrl: "https://x.com/triumph_games",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "04d7c662-9789-45f4-90eb-ef230b98ba8e-triumph-follow-x-completed",
    ruleId: "triumph-follow-x",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord",
    caption: "Join our massively growing community",
    linkUrl: "https://discord.com/invite/triumphgames",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "04d7c662-9789-45f4-90eb-ef230b98ba8e-triumph-follow-discord-completed",
    ruleId: "triumph-follow-discord",
  },
  {
    type: "link",
    key: "telegram-v2",
    icon: "Telegram",
    label: "Join Telegram Channel",
    caption: "Get the latest updates",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "04d7c662-9789-45f4-90eb-ef230b98ba8e-triumph-join-telegram-completed",
    ruleId: "triumph-join-telegram",
    linkUrl: "https://t.me/TriumphGames",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Subscribe to YouTube channel",
    caption: "Stay up to date with the latest content",
    linkUrl: "https://www.youtube.com/@TriumphOnChain",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "04d7c662-9789-45f4-90eb-ef230b98ba8e-triumph-follow-youtube-completed",
    ruleId: "triumph-follow-youtube",
  },
  {
    type: "link",
    key: "website",
    icon: "ApplicationWeb",
    label: "Follow Legends of Elumia on Epic Games",
    caption: "Dive into the Legends of Elumia universe",
    linkUrl: "https://store.epicgames.com/en-US/p/legends-of-elumia-0383a8",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "04d7c662-9789-45f4-90eb-ef230b98ba8e-triumph-elumia-epic-completed",
    ruleId: "triumph-elumia-epic",
  },
];

const triumphEngageQuests: Quest[] = [
  {
    type: "custom",
    key: "social-engagement",
    icon: "SupportChat",
    label: "Tag @Triumph_Games and post on X daily",
    caption: "Earn points everyday",
    increase: 40,
    badgeIcon: "Sparkle",
    recurring: true,
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "04d7c662-9789-45f4-90eb-ef230b98ba8e-x-social-engagement-completed",
    ruleId: "triumph-x-social-engagement",
  },
  {
    type: "custom",
    key: "social-engagement",
    icon: "SupportChat",
    label: "Post a message and engage in the Telegram channel daily",
    caption: "Earn points everyday",
    increase: 40,
    badgeIcon: "Sparkle",
    recurring: true,
    badgeTemplate: "+<increase> <icon>",
    eventId:
      "04d7c662-9789-45f4-90eb-ef230b98ba8e-triumph-telegram-social-engagement-completed",
    ruleId: "triumph-telegram-social-engagement",
  },
];

export const triumphPointsQuests: QuestGroup[] = [
  {
    key: "connect",
    header: {
      image: "",
      description: "",
      title: "Connect",
    },
    totalGemsGranted: 0,
    quests: triumphConnectQuests,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "engage-daily",
    header: {
      image: "",
      description: "",
      title: "Engage Daily",
    },
    totalGemsGranted: 0,
    quests: triumphEngageQuests,
    questGroup: MAIN_QUESTS_GROUP,
  },
];
